













































































































































































import { mapGetters, mapMutations, mapState } from 'vuex'
import UrlHistoryService from '~/services/url/history/UrlHistoryService'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import CSlider from '~/components/shared/configurable/slider/CSlider.vue'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import {
  SET_LEASING_DURATION,
  SET_LEASING_OPTION,
  SET_LEASING_WITH_VAT
} from '~/store/modules/shared/classifieds/view/mutation-types'
import { LeasingOption } from '~/models/classified/leasing/types'
import {
  LEASING_DOWNPAYMENT_PARAM_NAME,
  LEASING_DURATION_PARAM_NAME,
  LEASING_LEASE_PARAM_NAME,
  LEASING_MILEAGE_PARAM_NAME,
  LEASING_WITH_VAT_PARAM_NAME
} from '~/constants/finance/leasing'
import LeasingWithVatCheckbox from '~/components/car/classifieds/leasing/LeasingWithVatCheckbox.vue'
import { mapDeps } from '~/plugins/dependency-container/utils'
import CPrice from '~/components/shared/configurable/CPrice.vue'
import CExpandableContent from '~/components/shared/configurable/expand/CExpandableContent.vue'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'
import { defineComponent } from '~/utils/nuxt3-migration'

export default defineComponent({
  components: {
    LeasingWithVatCheckbox,
    CPrice,
    CSlider,
    CExpandableContent
  },
  computed: {
    icons: () => ({
      check: faCheck
    }),
    ...mapState(CLASSIFIED_VIEW_NS, {
      leasingExtras: state => state.classified.leasing.extras,
      leasingOptions: state => state.classified.leasing.options,
      availableDurations: state => state.leasing.availableDurations,
      withVat: state => state.leasing.withVat,
      duration: state => state.leasing.duration,
      selectedOption: state => state.leasing.option
    }),
    ...mapGetters(CLASSIFIED_VIEW_NS, {
      getLeasingOptionFieldVatValue: 'getLeasingOptionFieldVatValue'
    }),

    ...mapGetters(USER_AGENT_NS, {
      isMobile: 'isMobile'
    }),
    ...mapDeps({
      historyService: UrlHistoryService
    }),
    hasMoreThanOneDuration() {
      return this.availableDurations.length > 1
    },
    selectedLeasingDurationOptions() {
      return this.leasingOptions.filter(
        (option: LeasingOption) =>
          Number(option.duration.value) === this.duration
      )
    },
    durationSliderOptions: () => ({
      processStyle: {
        backgroundColor: '#1976d2'
      },
      tooltipStyle: {
        backgroundColor: '#1976d2'
      },
      dotSize: 20
    }),
    selectedOptionPurchasePrice() {
      return (
        this.selectedOption &&
        this.selectedOption.purchasePrice &&
        this.getLeasingOptionFieldVatValue(this.selectedOption.purchasePrice)
      )
    },
    amountPerMonth() {
      const { lease } = this.selectedOption
      if (this.withVat) {
        return lease.valueWithVat
      }
      return lease.valueWithoutVat
    }
  },
  methods: {
    ...mapMutations(CLASSIFIED_VIEW_NS, {
      setLeasingWithVat: SET_LEASING_WITH_VAT,
      setLeasingDuration: SET_LEASING_DURATION,
      setLeasingOption: SET_LEASING_OPTION
    }),
    hasDownpayment(downpayment) {
      return downpayment.valueWithoutVat !== '0'
    },
    selectLeasingOption(option: LeasingOption) {
      if (option === this.selectedOption) {
        return
      }
      this.setLeasingOption(option)
      this.historyService.replaceQueryParams({
        [LEASING_DOWNPAYMENT_PARAM_NAME]: this.getLeasingOptionFieldVatValue(
          option.downpayment
        ),
        [LEASING_LEASE_PARAM_NAME]: this.getLeasingOptionFieldVatValue(
          option.lease
        ),
        [LEASING_MILEAGE_PARAM_NAME]: option.mileage.value,
        [LEASING_DURATION_PARAM_NAME]: this.duration
      })
    },
    handleWithVatChange(withVat: boolean) {
      this.setLeasingWithVat(withVat)
      const query = {
        [LEASING_WITH_VAT_PARAM_NAME]: withVat
      }
      if (this.selectedOption) {
        query[LEASING_LEASE_PARAM_NAME] = this.getLeasingOptionFieldVatValue(
          this.selectedOption.lease
        )
        query[
          LEASING_DOWNPAYMENT_PARAM_NAME
        ] = this.getLeasingOptionFieldVatValue(this.selectedOption.downpayment)
      }
      this.historyService.replaceQueryParams(query)
    },
    handleDurationChange(duration: string) {
      this.setLeasingDuration(duration)
      this.selectLeasingOption(this.selectedLeasingDurationOptions[0])
      this.historyService.replaceQueryParams({
        [LEASING_DURATION_PARAM_NAME]: duration
      })
    },
    leasingOptionIsSelected(option: LeasingOption) {
      return option === this.selectedOption
    }
  }
})
